import DeleteModal from "./DeleteModal";
import "./DeleteModal.scss";

export default DeleteModal;
